import {React, useEffect,useCallback} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer,toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import { useState } from 'react';
import _ from 'lodash';
import Index from '../Assets/Images/delete.png';

/*----function with pagination----*/

const pageSize = 5;

const ParoAddRoleMain = () => {

    
  const[Roletable, setRoletable] =useState([])      
  const token = JSON.parse(localStorage.getItem('usertoken')); 

  const [allusers,setAllusers]= useState([])

  const [paginatedPosts, setpaginatedPosts] = useState();
  //const [currentPage, setcurrentPage] = useState(1);
 


  useEffect(()=>{
    getParorole();
   
  },[])

 /*---Get Roles ----*/

function getParorole(){


    fetch(`${BASE_URL}/Paropakari/GetParoAddRole`, {
      method:'GET',

    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " +`${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },


})

.then(response => response.json())


.then(data => {
console.log("Section",data)

setAllusers(data)
setpaginatedPosts(_(data).slice(0).take(pageSize).value());
localStorage.setItem("Data", JSON.stringify(data));
});

console.log("check",allusers)
}



// const pageCount = allusers? Math.ceil(allusers.length/pageSize) : 0 ;
//   // if (pageCount === 1)
//   // return null;
  
//   const pages = _.range(1, pageCount+1)
  
//   const pagination =(pageNo)=>{
//   setcurrentPage(pageNo);
//   const startIndex = (pageNo-1) * pageSize;
//   const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
//   setpaginatedPosts(paginatedPost)
//   }
// -----AddRole-----//

function AddRole(){

  let input = document.getElementById('ParoRoleText').value;
  let alldata = localStorage.getItem("Data");

  console.log(alldata.role)

  let roledata =  JSON.parse(alldata);
console.log(roledata)


  let names = roledata.map((item) => item.role);
  console.log(names)


  let result = names.includes(input);  
console.log(result)  

if(result==true){
 toast.error(" Role Already Exists! ")
}
else{
 document.getElementById("Error").innerHTML="";


 var Role = document.getElementById('ParoRoleText').value;
 const token = JSON.parse(localStorage.getItem('usertoken')); 

 const body ={
  
  Role:Role,
  RoleValue:'01'

}
console.log(body);



  axios({

    method: "POST",

    url: `${BASE_URL}/Paropakari/ParoAddRole`,
    data:body,
    headers: {
      
      'Content-Type': 'multipart/form-data' ,    
      "Authorization": "Bearer " +`${token}`
     
    }
  
  })
 
  .then((response) =>{
    console.log(response.data);
     if(response.data.status === "Success"){

      alert(" Added Successfully!")
      //  toast.success("Role Added Successfully!", {
      //          position: "top-center",
      //          autoClose: 3200,
      //          hideProgressBar: false,
      //          closeOnClick: true,
      //          pauseOnHover: true,
      //          draggable: true,
      //          progress: undefined,
      //          className: 'toast-message'
      //          });
               setTimeout(() => {
                   
                     
                  //  window.location.reload();
                  getParorole();
                 document.getElementById("ParoAddRole").reset();

               }, 500);
             }
            
            })
     
   .catch(error => {
    console.log(error);
     alert("failed !")       
     })
 
    }

}


    const[roleAction,setRoleAction] = useState()

    function updateRoleAction(Id){
         
      let arr = [];
      let checkboxes = document.querySelectorAll("input[type='checkbox']:checked");
     
     checkboxes.forEach((item)=>{
        arr.push(item.value)
     }) 
    console.log(arr)
    
    
    
      var radioInput = arr.toString();
         
      const body ={
      
        roleValue: radioInput,      
        id:Id     
      
       }
       console.log(body);
      
       let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
        axios({          
           method: "POST", 
           url: `${BASE_URL}/Paropakari/ParoAddroleEdit`,      
          //  url: "https://localhost:44312/Api/Kdpcorp/CorpAddroleEdit",
           data:body,
           headers: {             
             'Content-Type': 'application/json' , 
             'Authorization':bearer     
           }
         
         })
         .then((response) =>{
          console.log(response.data);
                  
          alert("Assigned!");
          uncheckAll()
          getParorole() 
           }) 
          }

          function uncheckAll() {
            var inputs = document.querySelectorAll('.checkboxInput');
            for (var i = 0; i < inputs.length; i++) {
                inputs[i].checked = false;
            }
        }
    

  //-----DELETE FUNCTION -----//
  
  function ConfirmDelete(Id){
  
  
    document.getElementById("modalEditForm").style.display = "block";
    ParoSelectRole(Id)
  
  }
  
  
  function ParoSelectRole(Id){
  
    const token = JSON.parse(localStorage.getItem('usertoken'));
  
    // document.getElementById("DisplayEditPop").style.display = "block";
  
     const body =
      {
        
       id:Id
      }
      console.log('body',body);
  
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Paropakari/SelectParoRoleDelete`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer " +`${token}` 
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
       
            SetDeleteParoRole(response.data);
       
         })
         .catch(error => {
           console.log(error);
           
         })
  
   }
  
  //  ----------------------------------//
  




/*----Get select to the particular Id----*/

const [DeleteParoRole,SetDeleteParoRole] =useState([]);


  /*----del btn Onclick func----*/

  function  ParoAddRoleDelete(Id){

    const token = JSON.parse(localStorage.getItem('usertoken'));
  
    const body ={
      id: Id
    }
     console.log('check',body)
      axios({
     
      method:"POST",
     url:`${ BASE_URL}/Paropakari/ParoRoleDelete`,
     data:body,
     headers: {
     "Content-Type" : "application/json",
     "Authorization": "Bearer " + `${token}`,
  
   
     }
    
      })
      .then((response) =>{
      console.log(response.data);

      alert("Deleted Successfully !")
      // toast.info(" Content Deleted Successfully !", {
      //  position: "top-center",
      //  autoClose: 3200,
      //  hideProgressBar: false,
      //  closeOnClick: true,
      //  pauseOnHover: true,
      //  draggable: true,
      //  progress: undefined,
      //  className: 'toast-message'
      //  });
       setTimeout(() => {
        closeForm()
        getParorole() ;
       }, 500);
     
   
      })
   
  }

    

   /*----Open & Close Edit and Add popup----*/

function closeForm(){
   
  
  document.getElementById('modalEditForm').style.display="none";
  document.getElementById('form').reset();

 

 }       
          
 const LEFT_PAGE = "LEFT";
  const RIGHT_PAGE = "RIGHT";
  const range = (from, to, step = 1) => {
    let i = from;
    const range = [];
  
    while (i <= to) {
      range.push(i);
      i += step;
    }
  
    return range;
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  
  let data = localStorage.getItem("Data")
  let transdata =  JSON.parse(data);
  console.log(transdata,'aaaa')
  let NUM_OF_RECORDS = transdata.length;
  let LIMIT = 5;
  
  const onPageChanged = useCallback(
  
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
    
  );
  
  
  const currentData = transdata.slice(
    (currentPage - 1) * LIMIT,
    (currentPage - 1) * LIMIT + LIMIT
  );
  
  const Paginations = (props) => {
    const {
      totalRecords,
      pageLimit,
      pageNeighbours,
      onPageChanged,
      currentPage
    } = props;
    const [totalPages, setTotalPages] = useState(0);
    useEffect(() => {
      setTotalPages(Math.ceil(totalRecords / pageLimit));
    }, [setTotalPages]);
  
    const fetchPageNumbers = () => {
      const totalNumbers = pageNeighbours * 1 + 0;
    
      const totalBlocks = totalNumbers + 2;
     
      if (totalPages > totalBlocks) {
        const startPage = Math.max(2, currentPage - pageNeighbours);
        const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
  
        let pages = range(startPage, endPage);
  
        const hasLeftSpill = startPage > 2;
        const hasRightSpill = totalPages - endPage > 1;
        const spillOffset = totalNumbers - (pages.length + 1);
  
        switch (true) {
          case hasLeftSpill && !hasRightSpill: {
            const extraPages = range(startPage - spillOffset, startPage - 1);
            pages = [LEFT_PAGE, ...extraPages, ...pages];
            break;
          }
          case hasLeftSpill && hasRightSpill:
          default: {
            pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
            break;
          }
        }
        return [1, ...pages, totalPages];
      }
      return range(1, totalPages);
    };
  
  
    const pages = fetchPageNumbers() || [];
    return (
      <nav aria-label="Countries Pagination">
        <ul className="pagination" id='Paro-pag'>
          {pages.map((page, index) => {
            if (page === LEFT_PAGE)
              return (
                <li key={index} className="Paropage-item">
                  <a
                    href="/"
                    className="page-link"
                    aria-label="Previous"
                    onClick={(e) => onPageChanged(e, pageNeighbours)}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
              );
  
            if (page === RIGHT_PAGE)
              return (
                <li key={index} className="Paropage-item">
                  <a
                    className="page-link"
                    href="/"
                    aria-label="Next"
                    onClick={(e) => onPageChanged(e, pageNeighbours*2+1 )}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              );
  
            return (
              <li
                key={index}
                className={`Paropage-item${currentPage === page ? " active" : ""}`}
              >
                <a
                  className="page-link"
                  href="/"
                  onClick={(e) => onPageChanged(e, page)}
                >
                  {page}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };


  return (
    <div className='Paro-addmain'>

 <div className="Paro-addgrid-layout">

    <div className="Paro-addmain-top">
        <div className='Paro-addmain-back'>
           <Link to='/ParoAdduser'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Add Role</span>
 

     </div>

 </div>


 <div className='Paro-roletable'>
       {/* <div className="modal-dialog" role="document">
          <div className="modal-content"> */}

           
              <form id="ParoAddRole" >
              <div className="modal-body mx-4">

              <div className='col-sm-12'>
              <div className='row'> 

                  <div className='col-sm-6'>
                  <div className="md-form mb-0" id="Paroroletextholder">
         
                     <input type="text"  id="ParoRoleText" placeholder='Role'></input>
                     <span id="Error"></span>
                     </div>
                   </div>


                   <div className='col-sm-6'> 
                   <div className="md-form mb-0">
                   <div className="text-center" id="ParoAddbtnres">
                        <button type="submit" onClick={AddRole} className="Parorolebtn" id="paro-adduser-button">CREATE</button>
                  </div>
                  
                </div>
                </div>


                </div>
      
                

                </div>
                </div>

           </form>

          {/* </div>
     </div> */}
</div>

    
<div className='Paro-AddRoletable'>
        <div class="Paro-table-responsive">
       
        {
  !paginatedPosts ? ("No data found"):(
  <table> 
    <thead>
   <tr>
<th>Roles</th>
<th id="actionbtnparo">Action 




</th>
<th>AssignedAction</th>
<th>Delete</th>

</tr>
</thead>

<tbody>

{currentData.map((e)=>
            {
              return<tr>
                <td>{e.role}</td>
                
                <td style={{whiteSpace:"nowrap"}}>
                  <label><input type="checkbox" className='checkboxInput' id='radioInput' onChange={e=>setRoleAction(...roleAction,e.target.value)} name="optradio" value="Add" />Add
</label>
&nbsp;&nbsp;&nbsp;&nbsp;
<label><input type="checkbox"  className='checkboxInput' id='radioInput' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="View"/>View
</label>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<label><input type="checkbox"   className='checkboxInput' id='radioInput' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Edit"/>Edit
</label>
&nbsp;&nbsp;&nbsp;&nbsp;
<label><input type="checkbox"  className='checkboxInput'  id='radioInput' onChange={e=>setRoleAction(e.target.value)} name="optradio" value="Delete"/>Delete
</label>

                

&nbsp;&nbsp;&nbsp;&nbsp;
<button onClick={()=>updateRoleAction(e.id)} id="Parocheckbocbtn">Set</button>

 </td>
 {!e.userroleaction?<td>No Task Assigned</td>:
 <td>{e.userroleaction}</td>}
 <td>
  <span><i class="fa fa-refresh" aria-hidden="true"onClick={()=>ConfirmDelete(e.id)} id="ParoDelete-icon"></i></span>
  
  </td>
                



                 </tr>
            })} 

</tbody>


</table>
  )}

<br></br>
{transdata.length<=5? null:<div>

{

 !paginatedPosts ? (""):(

<Paginations



totalRecords={NUM_OF_RECORDS}

 pageLimit={LIMIT}

 pageNeighbours={2}

onPageChanged={onPageChanged}

currentPage={currentPage}

 />

 )}
 </div>
}
  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> */}
        
        
  </div>


    </div>

    <div className="Paropop-fade" id="modalEditForm" tabindex="-1" role="dialog">
   {DeleteParoRole.map((e)=>{
   return<div className="modal-dialog" role="document" id="ParocenterDelform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">DELETE</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5 id="Parodelformsize"> <img src={Index} id="causeimg"></img><br></br>Are you sure want to Clear the Actions?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className="Paro-delete-button" type='submit' onClick={()=>ParoAddRoleDelete(e.id)}>Confirm</button>
        <button className="Paro-delete-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
  })}
</div>

 </div>
  )
}

export default ParoAddRoleMain